import { OrderWithExtraInfo } from '@orbis-systems/orbis-api-middleware';
import { multiply } from './numberUtils';

export function formatOrderDecimalsForModify(
    order: OrderWithExtraInfo | null,
    decimalPlaces: number,
    mutualFundTrading: boolean,
) {
    return {
        quantity: !mutualFundTrading ? Number((order?.quantity || 0).toFixed(decimalPlaces)) : 0,
        stopPrice: Number(order?.stopPx?.toFixed(decimalPlaces)) || 0,
        limitPrice: Number(order?.limitPx?.toFixed(decimalPlaces)) || 0,
        value: mutualFundTrading
            ? Number(multiply(order?.quantity || 0, order?.expectedPx || 0).toFixed(decimalPlaces))
            : 0,
    };
}
